import React, { Component } from 'react'
import '../styles/OtherProjectList.css'
import deleteIcon from '../images/delete.png'
import addIcon from '../images/add.png'
import OrgFooter from '../widgets/OrgFooter'
import APIOtherProjectRequest from '../api/APIOtherProjectRequest'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'

class OtherProjectListNational extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			listItems: [],
			itemObj: {},
			keyTracer: 0,
			projects: {},
			deleteProjects: {},
			disabled: props.disabled
		}
		this.eventHandler = this.eventHandler.bind(this)
		this.setListItems = this.setListItems.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.addOtherProject = this.addOtherProject.bind(this)
		this.editOtherProject = this.editOtherProject.bind(this)
		this.getAllOtherProjects = this.getAllOtherProjects.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		const projects = []
		const addModules = []
		Object.values(this.state.projects).forEach((v) => {
			if(v.project_id != null) {
				this.editOtherProject(v)
			}
			else {
				this.addOtherProject({project_name: v.project_name})
			}
		})
	}

	addOtherProject(title) {
		const apiReq = APIOtherProjectRequest.addOtherProject(this.state.accessToken, title)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.error,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false,
			})
		})
	}

	editOtherProject(data) {
		const title = {project_name: data.project_name}
		const apiReq = APIOtherProjectRequest.editOtherProjectById(this.state.accessToken, title, data.project_id)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.error,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false,
			})
		})	}

	componentWillMount() {
		this.getAllOtherProjects()
	}

	getAllOtherProjects() {
		this.setState({showActivityIndicator: true})
		const apiReq = APIOtherProjectRequest.getAllOtherProjects(this.state.accessToken);
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			this.setListItems(response.results.rows)
		})
	}

	onResize() {
		this.setScrollable()
	}

	componentDidMount() {
		let data
		if(this.props.view === "add") {
			data = []
		}
		this.setScrollable()
		window.addEventListener('resize', this.onResize.bind(this))
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize.bind(this))
	}

	eventHandler(e, compId, key, value) {
		switch(e) {
			case "list-item":
				this.state.projects[compId] = value
				break
			case "add":
				const added = []
				const aeKey = "ae-" + this.state.keyTracer
				this.state.itemObj[aeKey] = <ListItem handler={this.eventHandler}
					disabled={this.state.disabled} key={aeKey} id={aeKey} />
				this.state.keyTracer++
				this.state.listItems.push(this.state.itemObj[aeKey])
				Object.keys(this.state.itemObj).forEach((k => {
					added.push(this.state.itemObj[k])
				}))
				this.setState({listItems: added})
				break
			case "delete":
				this.state.deleteProjects[compId] = value
				delete this.state.itemObj[compId]
				const deleted = []
				Object.keys(this.state.itemObj).forEach((k => {
					deleted.push(this.state.itemObj[k])
				}))
				this.setState({listItems: deleted})
		}
	}

	setListItems(items) {
		const listItems = []
		if(items != null) {
			for(const v of items) {
				const aeKey = "ae-" + this.state.keyTracer
				this.state.itemObj[aeKey] = <ListItem data={v} handler={this.eventHandler}
					disabled={this.state.disabled}  key={aeKey} id={aeKey} />
				this.state.keyTracer++
			}
			const aeKey = "ae-" + this.state.keyTracer
			this.state.itemObj[aeKey] = <ListItem handler={this.eventHandler}
				disabled={this.state.disabled} key={aeKey} id={aeKey} />
			this.state.keyTracer++
			Object.keys(this.state.itemObj).forEach((k => {
				listItems.push(this.state.itemObj[k])
			}))
		}
		this.setState({listItems: listItems, showActivityIndicator: false})
	}

	setScrollable() {
		const sa = document.getElementById('opl-scroll-area')
		const ca = document.getElementById('opl-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(this.props.view == null) {
			this.setState({scrollable: null})
			return
		}
		if(sa.clientHeight < ca.clientHeight+60) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	render() {
		const view = <div id="other-project-list">
			<div id="opl-scroll-area"><div id="opl-client-area">
			{this.state.listItems.length > 0 && <div id="opl-items">
				<div id="opl-label">Project Name</div>
				{this.state.listItems}
			</div>}
			</div>{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
				showSubmit={true} disabled={this.state.isViewDetails} />}</div>
			{this.state.scrollable === false && <div className="alternate-footer">
				<OrgFooter submit={this.onSubmit} disabled={this.state.isViewDetails} showSubmit={true} /></div>}
			{this.state.listItems.length === 0 && <div id="no-result"><div>NO RESULT</div></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
			}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{/* <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} /> */}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class ListItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			disabled: props.disabled,
			data: props.data,
			projects: {}
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentWillMount() {
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.projects["project_id"] = this.props.data.project_id
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.setState({
				addDeleteButton: addDeleteButton,
				projectTitle: this.props.data.project_name
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.member)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		this.props.handler("delete", this.state.itemId, null, this.state.member)
	}
	render() {
		const view = <div className="opl-list-item">
			<div>{this.state.addDeleteButton}</div>
			<input type="text" placeholder={this.state.projectTitle} onChange={(e) =>{
				this.state.projects["project_name"] = e.target.value
				this.props.handler("list-item", this.state.itemId, null, this.state.projects)
				if(this.state.addDeleteButton.props.alt == "ADD") {
					this.onAddItemClick()
				}
			}} disabled={this.state.disabled} />

		</div>
		return(view)
	}
}

export default OtherProjectListNational
